import React, { useEffect, useState } from "react"
import styled from "styled-components"
import dayjs, { Dayjs } from "dayjs"
import DatePicker from "react-datepicker"

import "react-datepicker/dist/react-datepicker.css"
import { useFormContext, useFormState } from "react-hook-form"
import { ErrorMessage } from "@hookform/error-message"
import FormLabel from "./FormLabel"
import ErrorField from "~/components/atoms/ErrorField"

interface Props {
  name: string
  isConfirm?: boolean
  placeholder?: string
  displayFormat?: string
  disabled?: boolean
  value?: string
  className?: string
  validations?: {
    required?: boolean
  }
  error?: string
  onChange?: (params: string) => any | null
}

export default function AcTimePicker(props: Props) {
  const { name, isConfirm = false, placeholder, displayFormat = "HH:mm", disabled = false, value, className, onChange, error, validations } = props
  const [date, setDate] = useState<Date | null>(null)
  const { register, setValue, formState } = useFormContext()
  const options = {}
  if (validations?.required) {
    Object.assign(options, {
      required: `${error || name}を入力してください`,
    })
  }
  useEffect(() => {
    const inputDate = dayjs(value)
    setDate(inputDate.isValid() ? inputDate.toDate() : null)
  }, [value])
  return isConfirm ? (
    <FormLabel className="form-label">{date ? dayjs(date).format(displayFormat) : ""}</FormLabel>
  ) : (
    <div className={className}>
      <EXDatePicker
        {...register(name, options)}
        autoComplete={"off"}
        className={"datepicker"}
        placeholder={placeholder}
        selected={date}
        onChange={(date) => {
          setDate(date)
          if (date) {
            const inputDate = dayjs(value)
            const ymd = (inputDate.isValid() ? inputDate : dayjs()).format("YYYY-MM-DD")
            const newDate = `${ymd} ${dayjs(date).format("HH:mm:00")}`
            const data = dayjs(newDate).toISOString()
            setValue(name, data)
            onChange?.apply(this, [data])
          } else {
            setValue(name, null)
            onChange?.apply(this, [null])
          }
        }}
        showTimeSelect
        showTimeSelectOnly
        timeIntervals={5}
        timeCaption="時間"
        dateFormat="HH:mm"
        timeFormat="HH:mm"
        disabled={disabled}
        autocomplite={false}
      />
      <ErrorMessage errors={formState.errors} name={name} render={({ message }) => <ErrorField>{message}</ErrorField>} />
    </div>
  )
}
const EXDatePicker = styled(DatePicker)`
  cursor: pointer;
  &.datepicker {
    font-size: 16px;
    display: block;
    width: 100%;
    border: 1px solid #bdbfc8;
    padding: 13px 10px;
    border-radius: 4px;
    background-color: #ffffff;
    ${(props) => props.disabled && `background-color: #f6f6f6 !important;`}
  }

  &.datepicker input {
    padding: 13px 35px 13px 13px;
    border: 1px solid #bdbfc8;
  }
`
